// extracted by mini-css-extract-plugin
export var cartContainer = "_j9-4";
export var gray = "_j9-1";
export var itemContainer = "_j9-2";
export var itemDetails = "_j9-3";
export var strong = "_j9-0";